import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import {
  ColDef,
  ColGroupDef,
  ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-enterprise";
import { EditAndDeleteButtons } from "../../../../../../../shared/data-entries/EditAndDeleteButtons";
import { ManualAutoButton } from "../../../../../../../shared/data-entries/ManualAutoButton";
import { Addition } from "../../../../models/eaf.models";

type Props = {
  deleteAddition: (additionId: number) => void;
  editAddition: (additionId: number) => void;
};

export const useTableData = ({ deleteAddition, editAddition }: Props) => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Additions",
      children: [
        {
          field: "manual-auto",
          headerName: " ",
          flex: 1,
          cellRenderer: ManualAutoButton,
          cellRendererParams: (params: ICellRendererParams<Addition>) => ({
            isManual: (params.data as Addition).IsAdditionManual,
          }),
        },
        {
          field: "Timestamp",
          headerName: "Time",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Addition>) => {
            if (params.data?.Timestamp) {
              return dxtToLocalServerTime(
                (params.data as Addition).Timestamp,
                "HH:mm",
              );
            }
          },
        },
        {
          field: "Source",
          headerName: "Source",
          flex: 2,
        },
        {
          field: "MaterialName",
          headerName: "Material",
          flex: 2,
        },
        {
          field: "Weight",
          headerName: "Weight [lbs]",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Addition>) =>
            params.data?.Weight?.toFixed(0) || "0",
        },
        {
          field: "actions",
          headerName: " ",
          flex: 2,
          cellRenderer: EditAndDeleteButtons,
          cellRendererParams: (params: ICellRendererParams<Addition>) => ({
            deleteItem: deleteAddition,
            onEdit: editAddition,
            id: (params.data as Addition).AdditionId,
          }),
        },
      ],
    },
  ];

  const defaultColDef: ColDef = {
    filter: false,
    floatingFilter: false,
    sortable: false,
    resizable: false,
    editable: false,
  };

  return { columns, defaultColDef };
};
